import { useQuery } from 'react-query';
import { getJobAgenda } from '../api/getJobAgenda';
import { JobAgendaSuccessResponse } from '../api/getJobAgenda.types';

export const useGetJobAgenda = (queryKey: string, from: string, to?: string, status?: string) =>
    useQuery<JobAgendaSuccessResponse, Error>([queryKey], () => getJobAgenda(from, to, status));
